import React from 'react'
import { useTranslation } from 'react-i18next'
import Fade from 'react-reveal/Fade'

const Competition = () => {
	const { t, i18n } = useTranslation()

	return (
		<section className='py-20 container mx-auto md:flex' id='competitions'>
			<Fade left cascade>
				<div className='md:w-5/12 pl-6'>
					<h2 className='font-bold text-xl md:text-5xl text-main-secondary_variant'>
						{t('translation:competitions:title')}
					</h2>
					<p className='my-4 text-sm md:text-xl leading-relaxed text-main-secondary w-full md:w-10/12'>
						{t('translation:competitions:subtitle')}
					</p>
					<p className='my-4 text-sm md:text-2xl leading-relaxed text-dark'>
						{t('translation:competitions:body')}
					</p>
					<a
						className='font-bold text-sm text-1xl text-main-secondary_variant underline'
						href='https://betish.com/'
					>
						{t('translation:competitions:link')}
					</a>
				</div>
			</Fade>
			<div className='w-full h-full md:w-7/12'>
				<Fade right>
					<img
						alt='Leaderboard'
						className='w-full rounded-betish shadow-card'
						src={`img/${i18n.languages[0]}-leaderboard.jpg`}
					/>
				</Fade>
			</div>
		</section>
	)
}

export default Competition
